/**
 * Created by eliranm on 29/10/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var _ = require('underscore');
    var Backbone = require('backbone');
    var Config = require('ui/file-upload-input/config/fileUploadInputConfig.json');
    var Utils = require('ui/file-upload-input/js/FileUploadInputUtils');
    var Translator = require("i18n/translator");

    var NO_TEXT_VALUE = "...";

    var FileUploadInputModel = Backbone.Model.extend({

        defaults: {
            wrapperClassNames: '',
            wrapperBaseClassName: Config.wrapperBaseClassName,
            permutationClassName: '',
            fileLabelClassName: Config.fileLabelClassName,
            frameContainerClassName: Config.fileUploadTransport.frameContainerClassName,
            noFileChosenMessage: Translator.translate(Config.i18n.noFileChosen)
        },


        // overridden

        initialize: function (options) {
            this._mixin(options);
            this._initAttributes();
        },


        // public

        getPermutation: function () {
            return this.permutation;
        },

        getIFrameLoadTimeout: function () {
            return this.iFrameLoadTimeout;
        },

        getUploadUrl: function () {
            return this.uploadUrl;
        },

        setUploadUrl: function (url) {
            this.uploadUrl = url;
        },

        getIFrameTitle: function () {
            return this.iFrameTitle;
        },

        getButtonText: function () {
            return this.buttonText;
        },

        getButtonStyle: function () {
            return this.buttonStyle;
        },

        getUploadTimeout: function () {
            return this.uploadTimeout;
        },

        isNativeStyles: function () {
            return this.nativeStyles;
        },

        getClassNames: function () {
            return this.classNames;
        },

        getErrorPosition: function () {
            return this.errorPosition;
        },

        isButtonOnRight: function() {
            return this.buttonOnRight;
        },

        isButtonTextEmpty: function() {
            return this.getButtonText() === NO_TEXT_VALUE;
        },

        /**
         * Returns the passed upload extensions array, pass true to prepend each item in the return array with a dot.
         * @param prependDots
         * @returns {Array}
         */
        getUploadExtensions: function (prependDots) {
            return prependDots ? Utils.prependEach(this.uploadExtensions, '.') : this.uploadExtensions;
        },

        getNoFileChosenMessage: function () {
            return this.get(FileUploadInputModel.KEYS.noFileChosenMessage);
        },


        // private

        /**
         * Mix in the passed object to the model.
         * @param obj
         * @private
         */
        _mixin: function (obj) {
            _.extend(this, obj);
        },

        _initAttributes: function () {
            this._initPermutationClassName();
            this._initCustomClassNames();
        },

        _initPermutationClassName: function () {
            this._silentSet(FileUploadInputModel.KEYS.permutationClassName, Config.permutationPrefix + this.getPermutation());
        },

        _initCustomClassNames: function () {
            // assign the wrapper classname value with the custom classnames array as space-delimited string
            this._silentSet(FileUploadInputModel.KEYS.wrapperClassNames, this.getClassNames().join(' '));
        },

        _silentSet: function (key, val) {
            this.set(key, val, {silent: true});
        }

    });

    FileUploadInputModel.KEYS = {
        wrapperClassNames: 'wrapperClassNames',
        wrapperBaseClassName: 'wrapperBaseClassName',
        permutationClassName: 'permutationClassName',
        noFileChosenMessage: 'noFileChosenMessage'
    };

    return FileUploadInputModel;
});
